"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _componentCommon = require("./component-common");

var _label = _interopRequireDefault(require("./label"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Row = function Row(props) {
  var elementWrapperClassName = props.elementWrapperClassName,
      required = props.required,
      rowClassName = props.rowClassName,
      showErrors = props.showErrors,
      layout = props.layout,
      label = props.label,
      children = props.children;
  var element = children;

  if (layout === 'elementOnly') {
    return /*#__PURE__*/_react["default"].createElement("span", null, element);
  }

  var cssClasses = {
    row: ['form-group'],
    elementWrapper: []
  };

  if (showErrors) {
    cssClasses.row.push('has-error');
    cssClasses.row.push('has-feedback');
  } // We should render the label if there is label text defined, or if the
  // component is required (so a required symbol is displayed in the label tag)


  var shouldRenderLabel = label !== null || required;

  if (layout === 'horizontal') {
    // Horizontal layout needs a 'row' class for Bootstrap 4
    cssClasses.row.push('row');

    if (!shouldRenderLabel) {
      cssClasses.elementWrapper.push('col-sm-offset-3');
    }

    cssClasses.elementWrapper.push('col-sm-9');
    cssClasses.elementWrapper.push(elementWrapperClassName);
    element = /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _dedupe["default"])(cssClasses.elementWrapper)
    }, element);
  }

  cssClasses.row.push(rowClassName);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _dedupe["default"])(cssClasses.row)
  }, shouldRenderLabel ? /*#__PURE__*/_react["default"].createElement(_label["default"], props) : null, element);
};

Row.propTypes = _objectSpread(_objectSpread({}, _componentCommon.styleClassNames), {}, {
  children: _propTypes["default"].node.isRequired,
  fakeLabel: _propTypes["default"].bool,
  htmlFor: _propTypes["default"].string,
  label: _propTypes["default"].node,
  layout: _propTypes["default"].oneOf(['horizontal', 'vertical', 'elementOnly']),
  required: _propTypes["default"].bool,
  showErrors: _propTypes["default"].bool
});
Row.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  elementWrapperClassName: '',
  labelClassName: '',
  rowClassName: '',

  /* eslint-enable */
  fakeLabel: false,
  htmlFor: null,
  label: null,
  layout: 'horizontal',
  required: false,
  showErrors: false
};
var _default = Row;
exports["default"] = _default;